import React, { useState, useCallback } from 'react'
import Box from '@material-ui/core/Box'
import Button from 'Components/Form/Button'

function DocumentCheckModalBody({
  onRefuse,
  onCancel,
  onApprove,
  item,
  isHideActiveButtons,
}) {
  const [disable, setDisable] = useState(false)
  const handleApprove = useCallback(() => {
    setDisable(true)
    onApprove()
  }, [onApprove])
  return (
    <Box mt={3} mb={3}>
      <Box display="flex" flexWrap="wrap" mt={3} mb={3}>
        {item.providedPersonalDocuments.edges.map(({ node: item }, index) => (
          <Box
            key={item.documentTypeName + index}
            width="40%"
            m={3}
            textAlign="center"
          >
            <span>{item.documentTypeName}</span>
            <br />
            <span>
              <a target="_blank" href={item.url} rel="noreferrer">
                Click here
              </a>
            </span>
          </Box>
        ))}
      </Box>
      <Box display="flex" flexWrap="wrap" justifyContent="center" mt={3} mb={3}>
        {!isHideActiveButtons && (
          <Box mx={1}>
            <Button value="Refuse" onClick={onRefuse} disabled={disable} />
          </Box>
        )}
        <Box mx={1}>
          <Button value="Cancel" onClick={onCancel} disabled={disable} />
        </Box>
        {!isHideActiveButtons && (
          <Box mx={1}>
            <Button
              value="Approve"
              onClick={handleApprove}
              disabled={disable}
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default DocumentCheckModalBody
